import React, { Component } from 'react';
// import axios from 'axios';

import './css/style.css';
import './App.css';

import Hero from './components/Hero';
// import Map from './components/Map';
// import Prijava from './components/Prijava';
// import Program from './components/Program';
// import Sponsors from './components/Sponsors';
import TwoSections from './components/TwoSections';
import ContactSection from './components/ContactSection';
import KalendarSusreta from './components/KalendarSusreta2018';

import data from './data/data.json';

class App extends Component {
  state = {
    hero: data.hero,
    kalendar: data.calendar,
    // program: data.meeting2022,
    // sponzori: data.meeting2022.sponsors,
    // team: data.club.members.list,
    contact: data.contact,
    // submissions: null,
  };

  componentDidMount() {
    // const config = {
    //   headers: {
    //     Authorization: `Bearer 05ed9a01b1fb25b1538e8fb86bba7b31c5d4b914`,
    //   },
    // };
    // const url = 'https://formspree.io/api/0/forms/xqknwjjn/submissions';
    // axios.get(url, config).then(res => {
    //   const submissions = res.data;
    //   this.setState({ submissions });
    // });
  }

  render() {
    return (
      <div>
        <Hero hero={this.state.hero} />
        {/* <Program program={this.state.program} /> */}
        {/* <Prijava prijava={this.state.program} submissions={this.state.submissions} /> */}
        {/* <Sponsors sponzori={this.state.sponzori} /> */}
        {/* <Map /> */}
        <KalendarSusreta kalendar={this.state.kalendar} />
        <TwoSections />
        <ContactSection contact={this.state.contact} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js